<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <usuario-form
            v-show="isModalVisible"
            @close="closeModal"
            :afterCreateAction="readData"
            :action="usuarioAction"
            :usuario="usuario"
          ></usuario-form>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>
    <template>
      <div class="content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <card
                class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
              >
                <template slot="header">
                  <div class="float-left">
                    <h4 class="card-title">Usuários Cadastrados</h4>
                  </div>
                  <div class="float-right">
                    <button
                      type="submit"
                      class="btn btn-success btn-fill"
                      @click="novoUsuario"
                    >
                      Cadastrar novo Usuário
                    </button>
                  </div>
                </template>

                <div class="ml-3 mb-4 mt-2">
                  <label for="perfil" class="mb-3">Filtros</label>
                  <div class="d-flex flex-column flex-sm-row">
                    <div
                      class="d-flex mr-0 mr-sm-5 mb-4 mb-sm-0 align-self-center"
                    >
                      <label
                        for="ativo"
                        class="d-flex align-items-center mb-0 pr-2"
                        >Nome</label
                      >
                      <input v-model="filtro.nome" class="form-control" />
                    </div>
                    <div class="d-flex">
                      <button @click="readData()" class="btn btn-success mr-2">
                        Filtrar
                      </button>
                      <button
                        @click="limparFiltrosEBuscarLista()"
                        class="btn btn-danger mr-2"
                      >
                        Limpar filtros
                      </button>
                    </div>
                  </div>
                </div>
                <l-table
                  class="table-hover table-striped"
                  :columns="tabelaUsuarios.columns"
                  :data="tabelaUsuarios.data"
                >
                  <template slot-scope="{ row }">
                    <td>{{ row.codigo }}</td>
                    <td>
                      <b>{{
                        row.tipoParceiro === 'pf'
                          ? `${row.nome} ${row.sobrenome}`
                          : row.razaoSocial
                      }}</b>
                    </td>
                    <td>
                      <span class="text-capitalize">{{
                        tipoUsuarioLabel[row.tipoUsuario]
                      }}</span>
                    </td>
                    <td>
                      <button
                        class="btn btn-icon btn-info"
                        style="margin-right: 10px"
                        title="Editar"
                        @click="editarUsuario(row)"
                      >
                        <i class="fa fa-pencil"></i>
                      </button>
                      <button
                        class="btn btn-icon btn-danger"
                        title="Excluir"
                        @click="handleDelete(row)"
                      >
                        <i class="fa fa-trash-o"></i>
                      </button>
                      <router-link
                        v-if="row.tipoUsuario === 'administrador'"
                        :to="{
                          name: 'RelatorioAnaliseReanalise',
                          params: { codigoParceiro: row.codigo },
                          query: {
                            nomeParceiro:
                              row.tipoParceiro === 'pf'
                                ? `${row.nome} ${row.sobrenome}`
                                : row.razaoSocial
                          }
                        }"
                      >
                        <button
                          class="btn btn-icon"
                          style="margin-left: 10px; color: #000"
                          title="Relatório Análise/Reanálise"
                        >
                          <i class="fa fa-line-chart"></i>
                        </button>
                      </router-link>
                    </td>
                  </template>
                </l-table>
                <template slot="footer">
                  <v-pagination
                    v-if="tabelaUsuarios.data.length > 0"
                    v-model="currentPage"
                    :page-count="totalPages"
                    :classes="bootstrapPaginationClasses"
                    :labels="paginationAnchorTexts"
                  ></v-pagination>
                </template>
              </card>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- DELETE MODAL -->
    <div v-show="isDeleteModalVisible" @close="closeModal">
      <transition name="modal-fade">
        <div class="modal-backdrop">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  <strong>Deseja realmente excluir o usuário?</strong>
                </h5>
              </div>
              <div class="modal-body">
                Esta ação é definitiva e não poderá ser desfeita.
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click.prevent
                  @click="closeDeleteModal()"
                >
                  Fechar
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click.prevent
                  @click="deleteUser()"
                >
                  Deletar
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import UsuarioForm from './Forms/UsuarioForm.vue';
import LTable from 'src/components/Table.vue';
import UserServices from 'src/services/usuarios';
import vPagination from 'vue-plain-pagination';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

const tableColumns = ['Id', 'Nome', 'Tipo'];
export default {
  components: {
    UsuarioForm,
    LTable,
    vPagination
  },
  data() {
    return {
      name: 'app',
      tabelaUsuarios: {
        columns: [...tableColumns],
        data: []
      },
      isModalVisible: false,
      usuarioAction: '',
      usuario: {},
      totalItens: Number,
      isDeleteModalVisible: false,
      userToDelete: {},
      currentPage: 1,
      totalPages: 1,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      },
      paginationAnchorTexts: {
        first: 'Primeira',
        prev: '<',
        next: '>',
        last: 'Última'
      },
      tipoUsuarioLabel: {
        vendedor: 'Vendedor',
        parceiro: 'Parceiro',
        colaborador: 'Colaborador',
        'colaborador-campo': 'Colaborador de Campo',
        administrador: 'Administrador'
      },
      filtro: {
        nome: ''
      }
    };
  },
  created() {
    this.readData();
  },
  methods: {
    readData() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });
      UserServices.listar({
        page: this.currentPage,
        nome: this.filtro.nome
      })
        .then(response => {
          loader.hide();
          this.tabelaUsuarios.data = _.get(response, 'data.result');
          this.totalItens = _.get(response, 'data.count');
          this.totalPages = Math.ceil(this.totalItens / 10);
        })
        .catch(error => {
          loader.hide();

          const message =
            _.get(error, 'response.status') === 400 &&
            _.has(error, 'response.data.message')
              ? _.get(error, 'response.data.message')
              : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

          this.$notifications.notify({
            message,
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger',
            icon: 'fa fa-exclamation-triangle'
          });
        });
    },
    maskPhone(tel) {
      tel = tel.replace(/\D/g, '');
      tel = tel.replace(/^(\d)/, '($1');
      tel = tel.replace(/(.{3})(\d)/, '$1)$2');
      if (tel.length == 9) {
        tel = tel.replace(/(.{1})$/, '-$1');
      } else if (tel.length == 10) {
        tel = tel.replace(/(.{2})$/, '-$1');
      } else if (tel.length == 11) {
        tel = tel.replace(/(.{3})$/, '-$1');
      } else if (tel.length == 12) {
        tel = tel.replace(/(.{4})$/, '-$1');
      } else if (tel.length > 12) {
        tel = tel.replace(/(.{4})$/, '-$1');
      }
      return tel;
    },
    maskCep(cep) {
      cep = cep.replace(/\D/g, '');
      cep = cep.replace(/^(\d{2})(\d)/, '$1.$2');
      cep = cep.replace(/\.(\d{3})(\d)/, '.$1-$2');
      return cep;
    },
    maskCpf(cpf) {
      cpf = cpf.replace(/\D/g, '');
      cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
      cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
      cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      return cpf;
    },
    maskCnpj(cnpj) {
      cnpj = cnpj.replace(/\D/g, '');
      cnpj = cnpj.replace(/^(\d{2})(\d)/, '$1.$2');
      cnpj = cnpj.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
      cnpj = cnpj.replace(/\.(\d{3})(\d)/, '.$1/$2');
      cnpj = cnpj.replace(/(\d{4})(\d)/, '$1-$2');
      return cnpj;
    },
    novoUsuario() {
      this.usuarioAction = 'NEW';
      this.usuario = {};
      this.isModalVisible = true;
    },
    editarUsuario(usuario) {
      this.usuarioAction = 'EDIT';
      if (usuario.cnpj) {
        usuario.cnpj = this.maskCnpj(usuario.cnpj);
      }
      if (usuario.cpf) {
        usuario.cpf = this.maskCpf(usuario.cpf);
      }
      usuario.cep = this.maskCep(usuario.cep);
      usuario.telefone = this.maskPhone(usuario.telefone);
      this.usuario = { ...usuario };
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    handleDelete(row) {
      this.isDeleteModalVisible = true;
      this.userToDelete = row;
    },
    closeDeleteModal() {
      this.isDeleteModalVisible = false;
      this.userToDelete = {};
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, icon) {
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    },
    limparFiltrosEBuscarLista() {
      this.filtro = {
        nome: ''
      };
      this.readData();
    },
    deleteUser() {
      const loader = this.$loading.show({
        container: this.$refs.loadingContainer,
        canCancel: true, // default false
        onCancel: this.yourMethodName,
        color: '#049F0C',
        loader: 'spinner',
        width: 64,
        height: 64,
        backgroundColor: '#ffffff',
        opacity: 0.5,
        zIndex: 999
      });

      const sucessCallback = () => {
        this.notifyVue(
          'top',
          'center',
          'success',
          'Deletado com Sucesso.',
          'fa fa-check'
        );
        this.readData();
        this.closeDeleteModal();
        loader.hide();
      };

      const errorCallback = err => {
        const message =
          _.get(err, 'response.status') === 400 &&
          _.has(err, 'response.data.message')
            ? _.get(err, 'response.data.message')
            : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

        this.notifyVue(
          'top',
          'center',
          'danger',
          message,
          'fa fa-exclamation-triangle'
        );
        loader.hide();
        this.closeDeleteModal();
        loader.hide();
      };

      UserServices.deletar(this.userToDelete)
        .then(sucessCallback)
        .catch(errorCallback);
    }
  },
  watch: {
    currentPage: function(newValue, oldValue) {
      if (this.currentPage !== oldValue) {
        this.readData();
      }
    }
  }
};
</script>
<style scope>
.pagination {
  justify-content: center;
  width: 100%;
  overflow: hidden;
  overflow-x: auto;
}
</style>
